import(/* webpackMode: "eager" */ "/vercel/path1/app/exchangers/page.tsx");
